/**
 * Version identifier recorded with each signup's Terms of Use / Privacy Policy
 * acceptance. Matches the "Effective Date" in athios_terms_of_use.md and
 * athios_privacy_policy.md — bump this manually whenever those documents change.
 */
export const CURRENT_LEGAL_VERSION = '2026-10-15'
